<template>
  <div class="modal-mask" v-if="$store.getters.USERPROFILE['sales-channel-administration']">
    <section v-if="!formStatus.created" class="modal reduced">
      <div class="content">
        <h1>{{$t('createSalesChannel.title')}}</h1>
      </div>
      <hr>
      <div class="content">
        <label>{{$t('createSalesChannel.name')}}</label>
        <div class="row">
          <div class="demiRow">
            <input type="text" v-model="newSalesChannel.name">
          </div>
          <p class="tips">{{$t('createSalesChannel.nameLegend')}}</p>
        </div>
        <p class="accentuate">{{$t('createSalesChannel.merchant')}}</p>
        <div class="row">
          <div class="demiRow">
            <input type="text" v-model="newSalesChannel['merchant-name']">
          </div>
          <p class="tips">{{$t('createSalesChannel.merchantLegend')}}</p>
        </div>
        <br>
        <button @click="add()">{{$t('button.createSalesChannel')}}</button>
        <a class="cancel" @click="$emit('close')">{{$t('button.cancel')}}</a>
      </div>
    </section>
  </div>
</template>

<script>
import SalesChannels from "@/services/SalesChannels.js";
export default {
  props: ["newAdd"],
  data() {
    return {
      newSalesChannel: {
        name: "",
        "merchant-name": ""
      },
      formStatus: {
        created: false
      }
    };
  },
  methods: {
    add() {
      SalesChannels.add(this.newSalesChannel).then(res => {
        // erreur a gerer + verif si le form est bien rempli
        if (res.status === 201) {
        let locationSplit = res.headers.location.split("/");
        var newSalesChannelId = locationSplit[locationSplit.length - 1];
          this.$emit("close");
          this.$emit("get");
          this.$emit("newchannel",newSalesChannelId);
        }
      });
    }
  }
};
</script>